import React from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";

/* CONFIG */
const sidebarConfig = {
  general: [
    { name: "Profile Settings", path: "/settings/general/profile", icon: "bi-person-circle" },
    { name: "Security Settings", path: "/settings/general/security", icon: "bi-shield-lock" },
    { name: "Notifications", path: "/settings/general/notifications", icon: "bi-bell" },
  ],

  website: [
    { name: "Business Settings", path: "/settings/website/business", icon: "bi-building" },
    { name: "SEO Settings", path: "/settings/website/seo", icon: "bi-search" },
    { name: "Localization", path: "/settings/website/localization", icon: "bi-geo-alt" },
    { name: "Prefixes", path: "/settings/website/prefixes", icon: "bi-hash" },
    { name: "Preferences", path: "/settings/website/preferences", icon: "bi-sliders" },
    { name: "Appearance", path: "/settings/website/appearance", icon: "bi-palette" },
  ],

  app: [
    { name: "Salary Settings", path: "/settings/app/salary", icon: "bi-cash-stack" },
    { name: "Approval Settings", path: "/settings/app/approval", icon: "bi-check2-circle" },
    { name: "Invoice Settings", path: "/settings/app/invoice", icon: "bi-receipt" },
    { name: "Leave Type", path: "/settings/app/leave-type", icon: "bi-calendar-event" },
    { name: "Custom Fields", path: "/settings/app/custom-fields", icon: "bi-input-cursor-text" },
  ],

  system: [
    { name: "Email Settings", path: "/settings/system/email", icon: "bi-envelope" },
    { name: "Email Templates", path: "/settings/system/email-templates", icon: "bi-file-text" },
    { name: "SMS Settings", path: "/settings/system/sms", icon: "bi-chat" },
    { name: "SMS Templates", path: "/settings/system/sms-templates", icon: "bi-chat-dots" },
    { name: "OTP", path: "/settings/system/otp", icon: "bi-shield-lock" },
    { name: "GDPR Cookies", path: "/settings/system/gdpr", icon: "bi-shield-check" },
    { name: "Maintenance Mode", path: "/settings/system/maintenance", icon: "bi-tools" },
  ],

  financial: [
    { name: "Payment Gateway", path: "/settings/financial/payment", icon: "bi-credit-card" },
    { name: "Tax Rates", path: "/settings/financial/tax", icon: "bi-percent" },
    { name: "Currencies", path: "/settings/financial/currencies", icon: "bi-currency-exchange" },
  ],

  other: [
    { name: "Custom CSS", path: "/settings/other/custom-css", icon: "bi-code-slash" },
    { name: "Custom JS", path: "/settings/other/custom-js", icon: "bi-filetype-js" },
    { name: "Cron Job", path: "/settings/other/cron", icon: "bi-clock-history" },
    { name: "Storage", path: "/settings/other/storage", icon: "bi-hdd" },
    { name: "Ban IP Address", path: "/settings/other/ban-ip", icon: "bi-ban" },
    { name: "Backup", path: "/settings/other/backup", icon: "bi-cloud-download" },
    { name: "Clear Cache", path: "/settings/other/clear", icon: "bi-trash" },
  ],
};                                 
/* ANIMATION */
const containerVariants = {
  hidden: { opacity: 0, x: -30 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: { opacity: 1, x: 0 },
};

const SettingsSidebar = ({ type = "general" }) => {
  const menuItems = sidebarConfig[type] || [];

  return (
    <motion.div
      className="bg-white border p-3 shadow-sm rounded"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {/* ✅ TITLE FIXED */}
      <h6 className="mb-3 fw-bold">
        {type === "general"
          ? "General Settings"
          : type === "app"
          ? "App Settings"
          : type === "website"
          ? "Website Settings"
          : type === "system"
          ? "System Settings"
          : type === "financial"
          ? "Financial Settings"
          : type === "other"
          ? "Other Settings"
          : "Settings"}
      </h6>

      <div className="d-flex flex-column gap-2">
        {menuItems.map((item, index) => (
          <NavLink
            key={index}
            to={item.path}
            style={{ textDecoration: "none" }}
          >
            {({ isActive }) => (
              <motion.div
                variants={itemVariants}
                whileHover={{ scale: 1.05, x: 6 }}
                whileTap={{ scale: 0.96 }}
                className="rounded px-3 py-2 position-relative overflow-hidden d-flex align-items-center"
                style={{
                  background: "#f8f9fa",
                  borderBottom: isActive
                    ? "2px solid rgb(118, 135, 155)"
                    : "2px solid transparent",
                  color: isActive ? "#0d6efd" : "#000",
                  cursor: "pointer",
                }}
              >
                {/* ICON */}
                {item.icon && (
                  <i className={`bi ${item.icon} me-2`}></i>
                )}

                {/* ACTIVE INDICATOR */}
                {isActive && (
                  <motion.div
                    layoutId="activeIndicator"
                    style={{
                      position: "absolute",
                      left: 0,
                      top: 0,
                      bottom: 0,
                      width: "4px",
                      background: "rgb(10, 35, 87)",
                      borderRadius: "4px",
                    }}
                  />
                )}

                {item.name}
              </motion.div>
            )}
          </NavLink>
        ))}
      </div>
    </motion.div>
  );
};

export default SettingsSidebar;